"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRAutoCache = void 0;
const cache_1 = require("../cache");
const store_1 = require("../store");
const xhr_1 = require("./xhr");
class XHRAutoCache {
    constructor(options) {
        this.xhr = (options === null || options === void 0 ? void 0 : options.xhr) || new xhr_1.XHR(options);
        this.cacheTTL = (options === null || options === void 0 ? void 0 : options.cacheTTL) || 1000;
        this.cache = (options === null || options === void 0 ? void 0 : options.cache) || new cache_1.CacheV2(new store_1.Store({ storage: store_1.StorageLocation.Memory }));
    }
    createCacheKey(url, body) {
        let key = `${url}`;
        if (body) {
            const sortedBodyKeys = Object.keys(body).sort();
            const sortedBody = sortedBodyKeys.reduce((obj, key) => {
                obj[key] = body[key];
                return obj;
            }, {});
            key += `:${JSON.stringify(sortedBody)}`;
        }
        return key;
    }
    clearCache() {
        this.cache.cleanCache();
    }
    GET(urlRaw, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = this.createCacheKey(urlRaw, xhrOptions === null || xhrOptions === void 0 ? void 0 : xhrOptions.params);
            const data = this.cache.getCached(key);
            if (!data) {
                const response = yield this.xhr.GET(urlRaw, xhrOptions);
                if (response.ok) {
                    this.cache.setCached(key, response, this.cacheTTL);
                }
                return response;
            }
            return data;
        });
    }
    POST(url, body, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.xhr.POST(url, body, xhrOptions);
            if (response.ok) {
                this.cache.cleanCache();
            }
            return response;
        });
    }
    PUT(url, body, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.xhr.PUT(url, body, xhrOptions);
            if (response.ok) {
                this.cache.cleanCache();
            }
            return response;
        });
    }
    PATCH(url, body, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.xhr.PATCH(url, body, xhrOptions);
            if (response.ok) {
                this.cache.cleanCache();
            }
            return response;
        });
    }
    DELETE(url, body, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.xhr.DELETE(url, body, xhrOptions);
            if (response.ok) {
                this.cache.cleanCache();
            }
            return response;
        });
    }
}
exports.XHRAutoCache = XHRAutoCache;
//# sourceMappingURL=xhrAutoCache.js.map